import script from "./contentsMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contentsMainPage.vue?vue&type=script&setup=true&lang=js"

import "./contentsMainPage.vue?vue&type=style&index=0&id=48d9db65&lang=css"

const __exports__ = script;

export default __exports__